import React, { createContext, useContext, useState } from 'react';

const DataContext = createContext();
const IsPerformedContext = createContext();

export const CalendarActionsProvider = ({ children, ...props }) => {
  const isPerformedState = useState(false);

  return (
    <DataContext.Provider value={props}>
      <IsPerformedContext.Provider value={isPerformedState}>
        {children}
      </IsPerformedContext.Provider>
    </DataContext.Provider>
  );
};

export const CalendarActionsController = ({
  component: Component,
  ...props
}) => {
  const [isPerformed] = useContext(IsPerformedContext);

  return <Component {...props} loading={isPerformed} />;
};

export const useCalendarActionsData = () => useContext(DataContext);
export const useCalendarActionPerformedState = () =>
  useContext(IsPerformedContext);
